{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "HEADER": "Shopify",
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Отмени",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integrations",
    "DESCRIPTION": "Chatwoot integrates with multiple tools and services to improve your team's efficiency. Explore the list below to configure your favorite apps.",
    "LEARN_MORE": "Learn more about integrations",
    "LOADING": "Fetching integrations",
    "SEARCH_PLACEHOLDER": "Search integrations...",
    "NO_RESULTS": "No integrations found matching your search",
    "CAPTAIN": {
      "DISABLED": "Captain is not enabled on your account.",
      "CLICK_HERE_TO_CONFIGURE": "Click here to configure",
      "LOADING_CONSOLE": "Loading Captain Console...",
      "FAILED_TO_LOAD_CONSOLE": "Failed to load Captain Console. Please refresh and try again."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Subscribed Events",
      "LEARN_MORE": "Learn more about webhooks",
      "PAYWALL": {
        "TITLE": "Webhooks are available on paid plans",
        "AVAILABLE_ON": "Use webhooks to receive real-time events from your Chatwoot account.",
        "UPGRADE_PROMPT": "Upgrade to the Startups, Business, or Enterprise plan to use webhooks.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "Change or cancel your plan anytime."
      },
      "SECRET": {
        "LABEL": "Secret",
        "COPY": "Copy secret to clipboard",
        "COPY_SUCCESS": "Secret copied to clipboard",
        "TOGGLE": "Toggle secret visibility",
        "CREATED_DESC": "Your webhook has been created. Use the secret below to verify webhook signatures. Please copy it now — you can also find it later in the webhook edit form.",
        "DONE": "Done"
      },
      "COUNT": "{n} webhook | {n} webhooks",
      "SEARCH_PLACEHOLDER": "Search webhooks...",
      "NO_RESULTS": "No webhooks found matching your search",
      "FORM": {
        "CANCEL": "Отмени",
        "DESC": "Webhook events provide you the realtime information about what's happening in your Chatwoot account. Please enter a valid URL to configure a callback.",
        "SUBSCRIPTIONS": {
          "LABEL": "Events",
          "EVENTS": {
            "CONVERSATION_CREATED": "Conversation Created",
            "CONVERSATION_STATUS_CHANGED": "Conversation Status Changed",
            "CONVERSATION_UPDATED": "Conversation Updated",
            "MESSAGE_CREATED": "Message created",
            "MESSAGE_UPDATED": "Message updated",
            "WEBWIDGET_TRIGGERED": "Live chat widget opened by the user",
            "CONTACT_CREATED": "Contact created",
            "CONTACT_UPDATED": "Contact updated",
            "CONVERSATION_TYPING_ON": "Conversation Typing On",
            "CONVERSATION_TYPING_OFF": "Conversation Typing Off",
            "INBOX_UPDATED": "Inbox updated"
          }
        },
        "NAME": {
          "LABEL": "Webhook Name",
          "PLACEHOLDER": "Enter the name of the webhook"
        },
        "END_POINT": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Please enter a valid URL"
        },
        "EDIT_SUBMIT": "Update webhook",
        "ADD_SUBMIT": "Create webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Configure",
      "HEADER": "Webhook settings",
      "HEADER_BTN_TXT": "Add new webhook",
      "LOADING": "Fetching attached webhooks",
      "SEARCH_404": "Няма резултати отговарящи на тази заявка",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>Webhooks are HTTP callbacks which can be defined for every account. They are triggered by events like message creation in Chatwoot. You can create more than one webhook for this account. <br /><br /> For creating a <b>webhook</b>, click on the <b>Add new webhook</b> button. You can also remove any existing webhook by clicking on the Delete button.</p>",
      "LIST": {
        "404": "There are no webhooks configured for this account.",
        "TITLE": "Manage webhooks",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Webhook endpoint",
          "ACTIONS": "Действия"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Редактирай",
        "TITLE": "Edit webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook configuration updated successfully",
          "ERROR_MESSAGE": "Не можа да се свърже с Woot сървър. Моля, опитайте отново по-късно"
        }
      },
      "ADD": {
        "CANCEL": "Отмени",
        "TITLE": "Add new webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook configuration added successfully",
          "ERROR_MESSAGE": "Не можа да се свърже с Woot сървър. Моля, опитайте отново по-късно"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Изтрий",
        "API": {
          "SUCCESS_MESSAGE": "Webhook deleted successfully",
          "ERROR_MESSAGE": "Не можа да се свърже с Woot сървър. Моля, опитайте отново по-късно"
        },
        "CONFIRM": {
          "TITLE": "Потвърди изтриването",
          "MESSAGE": "Are you sure to delete the webhook? ({webhookURL})",
          "YES": "Да, изтрий ",
          "NO": "No, Keep it"
        }
      }
    },
    "SLACK": {
      "HEADER": "Slack",
      "DELETE": "Изтрий",
      "DELETE_CONFIRMATION": {
        "TITLE": "Delete the integration",
        "MESSAGE": "Are you sure you want to delete the integration? Doing so will result in the loss of access to conversations on your Slack workspace."
      },
      "HELP_TEXT": {
        "TITLE": "Using Slack Integration",
        "BODY": "With this integration, all of your incoming conversations will be synced to the ***{selectedChannelName}*** channel in your Slack workspace. You can manage all your customer conversations right within the channel and never miss a message.\n\nHere are the main features of the integration:\n\n**Respond to conversations from within Slack:** To respond to a conversation in the ***{selectedChannelName}*** Slack channel, simply type out your message and send it as a thread. This will create a response back to the customer through Chatwoot. It's that simple!\n\n **Create private notes:** If you want to create private notes instead of replies, start your message with ***`note:`***. This ensures that your message is kept private and won't be visible to the customer.\n\n**Associate an agent profile:** If the person who replied on Slack has an agent profile in Chatwoot under the same email, the replies will be associated with that agent profile automatically. This means you can easily track who said what and when. On the other hand, when the replier doesn't have an associated agent profile, the replies will appear from the bot profile to the customer.",
        "SELECTED": "selected"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Select a channel",
        "UPDATE": "Обновяване",
        "BUTTON_TEXT": "Connect channel",
        "DESCRIPTION": "Your Slack workspace is now linked with Chatwoot. However, the integration is currently inactive. To activate the integration and connect a channel to Chatwoot, please click the button below.\n\n**Note:** If you are attempting to connect a private channel, add the Chatwoot app to the Slack channel before proceeding with this step.",
        "ATTENTION_REQUIRED": "Attention required",
        "EXPIRED": "Your Slack integration has expired. To continue receiving messages on Slack, please delete the integration and connect your workspace again."
      },
      "UPDATE_ERROR": "There was an error updating the integration, please try again",
      "UPDATE_SUCCESS": "The channel is connected successfully",
      "FAILED_TO_FETCH_CHANNELS": "There was an error fetching the channels from Slack, please try again"
    },
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Click here to join",
      "LEAVE_THE_ROOM": "Leave the room",
      "START_VIDEO_CALL_HELP_TEXT": "Start a new video call with the customer",
      "JOIN_ERROR": "There was an error joining the call, please try again",
      "CREATE_ERROR": "There was an error creating a meeting link, please try again"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI Assist",
      "WITH_AI": " {option} with AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Reply Suggestion",
        "SUMMARIZE": "Summarize",
        "REPHRASE": "Improve Writing",
        "FIX_SPELLING_GRAMMAR": "Fix Spelling and Grammar",
        "SHORTEN": "Shorten",
        "EXPAND": "Expand",
        "MAKE_FRIENDLY": "Change message tone to friendly",
        "MAKE_FORMAL": "Use formal tone",
        "SIMPLIFY": "Simplify",
        "CONFIDENT": "Use confident tone",
        "PROFESSIONAL": "Use professional tone",
        "CASUAL": "Use casual tone",
        "STRAIGHTFORWARD": "Use straightforward tone"
      },
      "REPLY_OPTIONS": {
        "IMPROVE_REPLY": "Improve reply",
        "IMPROVE_REPLY_SELECTION": "Improve the selection",
        "CHANGE_TONE": {
          "TITLE": "Change tone",
          "OPTIONS": {
            "PROFESSIONAL": "Professional",
            "CASUAL": "Casual",
            "STRAIGHTFORWARD": "Straightforward",
            "CONFIDENT": "Confident",
            "FRIENDLY": "Friendly"
          }
        },
        "GRAMMAR": "Fix grammar & spelling",
        "SUGGESTION": "Suggest a reply",
        "SUMMARIZE": "Summarize the conversation",
        "ASK_COPILOT": "Ask Copilot"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Draft content",
        "GENERATED_TITLE": "Generated content",
        "AI_WRITING": "AI is writing",
        "BUTTONS": {
          "APPLY": "Use this suggestion",
          "CANCEL": "Отмени"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integrate with OpenAI",
        "DESC": "Bring advanced AI features to your dashboard with OpenAI's GPT models. To begin, enter the API key from your OpenAI account.",
        "KEY_PLACEHOLDER": "Enter your OpenAI API key",
        "BUTTONS": {
          "NEED_HELP": "Need help?",
          "DISMISS": "Dismiss",
          "FINISH": "Finish Setup"
        },
        "DISMISS_MESSAGE": "You can setup OpenAI integration later Whenever you want.",
        "SUCCESS_MESSAGE": "OpenAI integration setup successfully"
      },
      "TITLE": "Improve With AI",
      "SUMMARY_TITLE": "Summary with AI",
      "REPLY_TITLE": "Reply suggestion with AI",
      "SUBTITLE": "An improved reply will be generated using AI, based on your current draft.",
      "TONE": {
        "TITLE": "Tone",
        "OPTIONS": {
          "PROFESSIONAL": "Professional",
          "FRIENDLY": "Friendly"
        }
      },
      "BUTTONS": {
        "GENERATE": "Generate",
        "GENERATING": "Generating...",
        "CANCEL": "Отмени"
      },
      "GENERATE_ERROR": "There was an error processing the content, please try again"
    },
    "DELETE": {
      "BUTTON_TEXT": "Изтрий",
      "API": {
        "SUCCESS_MESSAGE": "Integration deleted successfully"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Connect"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Dashboard Apps",
      "HEADER_BTN_TXT": "Add a new dashboard app",
      "SIDEBAR_TXT": "<p><b>Dashboard Apps</b></p><p>Dashboard Apps allow organizations to embed an application inside the Chatwoot dashboard to provide the context for customer support agents. This feature allows you to create an application independently and embed that inside the dashboard to provide user information, their orders, or their previous payment history.</p><p>When you embed your application using the dashboard in Chatwoot, your application will get the context of the conversation and contact as a window event. Implement a listener for the message event on your page to receive the context.</p><p>To add a new dashboard app, click on the button 'Add a new dashboard app'.</p>",
      "DESCRIPTION": "Dashboard Apps allow organizations to embed an application inside the dashboard to provide the context for customer support agents. This feature allows you to create an application independently and embed that to provide user information, their orders, or their previous payment history.",
      "LEARN_MORE": "Learn more about Dashboard Apps",
      "COUNT": "{n} dashboard app | {n} dashboard apps",
      "SEARCH_PLACEHOLDER": "Search dashboard apps...",
      "NO_RESULTS": "No dashboard apps found matching your search",
      "LIST": {
        "404": "There are no dashboard apps configured on this account yet",
        "LOADING": "Fetching dashboard apps...",
        "TABLE_HEADER": {
          "NAME": "Име",
          "ENDPOINT": "Endpoint",
          "ACTIONS": "Действия"
        },
        "EDIT_TOOLTIP": "Edit app",
        "DELETE_TOOLTIP": "Delete app"
      },
      "FORM": {
        "TITLE_LABEL": "Име",
        "TITLE_PLACEHOLDER": "Enter a name for your dashboard app",
        "TITLE_ERROR": "A name for the dashboard app is required",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Enter the endpoint URL where your app is hosted",
        "URL_ERROR": "A valid URL is required"
      },
      "CREATE": {
        "HEADER": "Add a new dashboard app",
        "FORM_SUBMIT": "Изпращане",
        "FORM_CANCEL": "Отмени",
        "API_SUCCESS": "Dashboard app configured successfully",
        "API_ERROR": "We couldn't create an app. Please try again later"
      },
      "UPDATE": {
        "HEADER": "Edit dashboard app",
        "FORM_SUBMIT": "Обновяване",
        "FORM_CANCEL": "Отмени",
        "API_SUCCESS": "Dashboard app updated successfully",
        "API_ERROR": "We couldn't update the app. Please try again later"
      },
      "DELETE": {
        "CONFIRM_YES": "Yes, delete it",
        "CONFIRM_NO": "No, keep it",
        "TITLE": "Потвърди изтриването",
        "MESSAGE": "Are you sure to delete the app - {appName}?",
        "API_SUCCESS": "Dashboard app deleted successfully",
        "API_ERROR": "We couldn't delete the app. Please try again later"
      }
    },
    "LINEAR": {
      "HEADER": "Linear",
      "ADD_OR_LINK_BUTTON": "Create/Link Linear Issue",
      "LOADING": "Fetching linear issues...",
      "LOADING_ERROR": "There was an error fetching the linear issues, please try again",
      "CREATE": "Създаване",
      "LINK": {
        "SEARCH": "Search issues",
        "SELECT": "Select issue",
        "TITLE": "Link",
        "EMPTY_LIST": "No linear issues found",
        "LOADING": "Loading",
        "ERROR": "There was an error fetching the linear issues, please try again",
        "LINK_SUCCESS": "Issue linked successfully",
        "LINK_ERROR": "There was an error linking the issue, please try again",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Create/link linear issue",
        "DESCRIPTION": "Create Linear issues from conversations, or link existing ones for seamless tracking.",
        "FORM": {
          "TITLE": {
            "LABEL": "Title",
            "PLACEHOLDER": "Enter title",
            "REQUIRED_ERROR": "Title is required"
          },
          "DESCRIPTION": {
            "LABEL": "Описание",
            "PLACEHOLDER": "Enter description"
          },
          "TEAM": {
            "LABEL": "Team",
            "PLACEHOLDER": "Изберете екип",
            "SEARCH": "Search team",
            "REQUIRED_ERROR": "Team is required"
          },
          "ASSIGNEE": {
            "LABEL": "Assignee",
            "PLACEHOLDER": "Select assignee",
            "SEARCH": "Search assignee"
          },
          "PRIORITY": {
            "LABEL": "Priority",
            "PLACEHOLDER": "Select priority",
            "SEARCH": "Search priority"
          },
          "LABEL": {
            "LABEL": "Label",
            "PLACEHOLDER": "Select label",
            "SEARCH": "Search label"
          },
          "STATUS": {
            "LABEL": "Статус",
            "PLACEHOLDER": "Select status",
            "SEARCH": "Search status"
          },
          "PROJECT": {
            "LABEL": "Project",
            "PLACEHOLDER": "Select project",
            "SEARCH": "Search project"
          }
        },
        "CREATE": "Създаване",
        "CANCEL": "Отмени",
        "CREATE_SUCCESS": "Issue created successfully",
        "CREATE_ERROR": "There was an error creating the issue, please try again",
        "LOADING_TEAM_ERROR": "There was an error fetching the teams, please try again",
        "LOADING_TEAM_ENTITIES_ERROR": "There was an error fetching the team entities, please try again"
      },
      "ISSUE": {
        "STATUS": "Статус",
        "PRIORITY": "Priority",
        "ASSIGNEE": "Assignee",
        "LABELS": "Етикети",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Unlink",
        "SUCCESS": "Issue unlinked successfully",
        "ERROR": "There was an error unlinking the issue, please try again"
      },
      "NO_LINKED_ISSUES": "No linked issues found",
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Yes, delete",
        "CANCEL": "Отмени"
      },
      "CTA": {
        "TITLE": "Connect to Linear",
        "AGENT_DESCRIPTION": "Linear workspace is not connected. Request your administrator to connect a workspace to use this integration.",
        "DESCRIPTION": "Linear workspace is not connected. Click the button below to connect your workspace to use this integration.",
        "BUTTON_TEXT": "Connect Linear workspace"
      }
    },
    "NOTION": {
      "HEADER": "Notion",
      "DELETE": {
        "TITLE": "Are you sure you want to delete the Notion integration?",
        "MESSAGE": "Deleting this integration will remove access to your Notion workspace and stop all related functionality.",
        "CONFIRM": "Yes, delete",
        "CANCEL": "Отмени"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Научете повече",
    "OVERVIEW": {
      "HEADER": "Overview",
      "WELCOME": {
        "LABEL": "Captain summary",
        "LOADING": "Generating summary…"
      },
      "INBOX_BANNER": {
        "TEXT": "This assistant isn't connected to any inbox yet, so it won't respond to conversations.",
        "ACTION": "Connect inbox",
        "DISMISS": "Dismiss"
      },
      "COVERAGE_BANNER": {
        "TEXT": "{count} FAQs are pending review, keeping coverage at {coverage}%. Approve them so your assistant can resolve more on its own.",
        "ACTION": "Review FAQs",
        "DISMISS": "Dismiss"
      },
      "RANGES": {
        "LAST_DAYS": "Last {count} days",
        "THIS_MONTH": "This month",
        "LAST_MONTH": "Last month"
      },
      "METRICS": {
        "HANDLED": {
          "LABEL": "Conversations handled",
          "HINT": "Distinct conversations this assistant replied in."
        },
        "AUTO_RESOLUTION": {
          "LABEL": "Auto-resolution rate",
          "HINT": "Share of handled conversations closed without a human reply."
        },
        "HANDOFF": {
          "LABEL": "Handoff rate",
          "HINT": "Share of handled conversations escalated to a human agent."
        },
        "HOURS_SAVED": {
          "LABEL": "Time saved",
          "HINT": "Estimate: Captain replies times ~2 minutes of assumed agent effort per reply. Directional, not measured labor."
        },
        "REOPEN": {
          "LABEL": "Reopen rate",
          "HINT": "Auto-resolved conversations that were reopened afterwards."
        },
        "DEPTH": {
          "LABEL": "Messages / conversation",
          "HINT": "Average replies the assistant sends per conversation."
        }
      },
      "DRILLDOWN": {
        "CLOSE": "Close details",
        "EMPTY": "No records found for this metric.",
        "ERROR": "Could not load records. Please try again.",
        "LOAD_MORE": "Load more",
        "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations"
      },
      "KNOWLEDGE": {
        "TITLE": "Knowledge coverage",
        "COVERAGE": "{pct}% approved",
        "APPROVED": "Approved FAQs",
        "PENDING": "Pending FAQs",
        "DOCUMENTS": "Documents"
      },
      "LINKS": {
        "DOCS": {
          "TITLE": "Captain docs",
          "DESCRIPTION": "Guides and how-tos for Captain"
        },
        "PLAYGROUND": {
          "TITLE": "Площадка",
          "DESCRIPTION": "Test this assistant's replies"
        },
        "BILLING": {
          "TITLE": "Billing",
          "DESCRIPTION": "Manage credits and plan"
        }
      }
    },
    "ASSISTANT_SWITCHER": {
      "ASSISTANTS": "Асистенти",
      "SWITCH_ASSISTANT": "Превключване между асистенти",
      "NEW_ASSISTANT": "Създайте асистент",
      "EMPTY_LIST": "Не са намерени асистенти, моля създайте един, за да започнете"
    },
    "COPILOT": {
      "TITLE": "Copilot",
      "TRY_THESE_PROMPTS": "Try these prompts",
      "PANEL_TITLE": "Започнете с Copilot",
      "KICK_OFF_MESSAGE": "Имате нужда от бързо резюме, искате да проверите минали разговори или да създадете по-добър отговор? Copilot е тук, за да ускори нещата.",
      "SEND_MESSAGE": "Изпрати съобщение...",
      "EMPTY_MESSAGE": "Възникна грешка при генериране на отговора. Моля, опитайте отново.",
      "LOADER": "Captain мисли",
      "YOU": "You",
      "USE": "Използвай това",
      "RESET": "Нулиране",
      "SHOW_STEPS": "Покажи стъпки",
      "SELECT_ASSISTANT": "Изберете асистент",
      "PROMPTS": {
        "SUMMARIZE": {
          "LABEL": "Обобщете този разговор",
          "CONTENT": "Обобщете основните точки, обсъдени между клиента и поддържащия агент, включително притесненията на клиента, въпросите и решенията или отговорите, предоставени от агента."
        },
        "SUGGEST": {
          "LABEL": "Предложете отговор",
          "CONTENT": "Анализирайте запитването на клиента и създайте отговор, който ефективно адресира техните притеснения или въпроси. Уверете се, че отговорът е ясен, кратък и предоставя полезна информация."
        },
        "RATE": {
          "LABEL": "Оценете този разговор",
          "CONTENT": "Прегледайте разговора, за да видите доколко отговаря на нуждите на клиента. Споделете оценка от 5 въз основа на тон, яснота и ефективност."
        },
        "HIGH_PRIORITY": {
          "LABEL": "Разговори с висок приоритет",
          "CONTENT": "Дайте ми резюме на всички отворени разговори с висок приоритет. Включете ID на разговора, името на клиента (ако е налично), съдържанието на последното съобщение и назначен агент. Групирайте по статус, ако е приложимо."
        },
        "LIST_CONTACTS": {
          "LABEL": "Списък с контакти",
          "CONTENT": "Покажете ми списък с топ 10 контакта. Включете име, имейл или телефонен номер (ако е наличен), време на последно виждане, етикети (ако има такива)."
        }
      }
    },
    "PLAYGROUND": {
      "USER": "You",
      "ASSISTANT": "Асистент",
      "MESSAGE_PLACEHOLDER": "Напишете вашето съобщение...",
      "HEADER": "Площадка",
      "DESCRIPTION": "Използвайте тази площадка, за да изпращате съобщения до вашия асистент и да проверите дали отговаря точно, бързо и в очаквания тон.",
      "CREDIT_NOTE": "Изпратените съобщения тук ще се броят към вашите кредити на Captain."
    },
    "PAYWALL": {
      "TITLE": "Надградете, за да използвате Captain AI",
      "AVAILABLE_ON": "Captain не е наличен в безплатния план.",
      "UPGRADE_PROMPT": "Надградете вашия план, за да получите достъп до нашите асистенти, copilot и още.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI е наличен само в Enterprise плановете.",
      "UPGRADE_PROMPT": "Надградете вашия план, за да получите достъп до нашите асистенти, copilot и още.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "BANNER": {
      "RESPONSES": "Използвали сте над 80% от лимита си за отговори. За да продължите да използвате Captain AI, моля надградете.",
      "DOCUMENTS": "Достигнат е лимитът за документи. Надградете, за да продължите да използвате Captain AI."
    },
    "FORM": {
      "CANCEL": "Отмени",
      "CREATE": "Създаване",
      "EDIT": "Обновяване"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "NO_ASSISTANTS_AVAILABLE": "There are no assistants available in your account.",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "UPDATE": "Update",
        "SECTIONS": {
          "BASIC_INFO": "Basic Information",
          "SYSTEM_MESSAGES": "System Messages",
          "INSTRUCTIONS": "Instructions",
          "FEATURES": "Features",
          "TOOLS": "Tools "
        },
        "NAME": {
          "LABEL": "Име",
          "PLACEHOLDER": "Enter assistant name",
          "ERROR": "The name is required"
        },
        "DESCRIPTION": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Enter assistant description",
          "ERROR": "The description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter product name",
          "ERROR": "The product name is required"
        },
        "WELCOME_MESSAGE": {
          "LABEL": "Welcome Message",
          "PLACEHOLDER": "Enter welcome message"
        },
        "HANDOFF_MESSAGE": {
          "LABEL": "Handoff Message",
          "PLACEHOLDER": "Enter handoff message"
        },
        "RESOLUTION_MESSAGE": {
          "LABEL": "Resolution Message",
          "PLACEHOLDER": "Enter resolution message"
        },
        "INSTRUCTIONS": {
          "LABEL": "Instructions",
          "PLACEHOLDER": "Enter instructions for the assistant"
        },
        "FEATURES": {
          "TITLE": "Features",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions.",
          "ALLOW_CITATIONS": "Include source citations in responses",
          "ALLOW_CONTACT_ATTRIBUTES": "Allow access to contact information"
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again.",
        "NOT_FOUND": "Could not find the assistant. Please try again."
      },
      "SETTINGS": {
        "HEADER": "Settings",
        "BASIC_SETTINGS": {
          "TITLE": "Basic settings",
          "DESCRIPTION": "Customize what the assistant says when ending a conversation or transferring to a human."
        },
        "SYSTEM_SETTINGS": {
          "TITLE": "System settings",
          "DESCRIPTION": "Customize what the assistant says when ending a conversation or transferring to a human."
        },
        "CONTROL_ITEMS": {
          "TITLE": "The Fun Stuff",
          "DESCRIPTION": "Add more control to the assistant. (a bit more visual like a story : Query guardrail → scenarios → output) Nudges user to actually utilise these.",
          "OPTIONS": {
            "GUARDRAILS": {
              "TITLE": "Guardrails",
              "DESCRIPTION": "Keeps things on track—only the kinds of questions you want your assistant to answer, nothing off-limits or off-topic."
            },
            "RESPONSE_GUIDELINES": {
              "TITLE": "Response guidelines",
              "DESCRIPTION": "The vibe and structure of your assistant’s replies—clear and friendly? Short and snappy? Detailed and formal?"
            }
          }
        },
        "DELETE": {
          "TITLE": "Delete Assistant",
          "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
          "BUTTON_TEXT": "Delete {assistantName}"
        }
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      },
      "GUARDRAILS": {
        "TITLE": "Guardrails",
        "DESCRIPTION": "Keeps things on track—only the kinds of questions you want your assistant to answer, nothing off-limits or off-topic.",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Изтрий"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example guardrails",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "SAVE": "Add and save (↵)",
            "PLACEHOLDER": "Type in another guardrail..."
          },
          "NEW": {
            "TITLE": "Add a guardrail",
            "CREATE": "Create",
            "CANCEL": "Отмени",
            "PLACEHOLDER": "Type in another guardrail...",
            "TEST_ALL": "Test all"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Search..."
        },
        "EMPTY_MESSAGE": "No guardrails found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No guardrails found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Guardrails added successfully",
            "ERROR": "There was an error adding guardrails, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Guardrails updated successfully",
            "ERROR": "There was an error updating guardrails, please try again."
          },
          "DELETE": {
            "SUCCESS": "Guardrails deleted successfully",
            "ERROR": "There was an error deleting guardrails, please try again."
          }
        }
      },
      "RESPONSE_GUIDELINES": {
        "TITLE": "Response Guidelines",
        "DESCRIPTION": "The vibe and structure of your assistant’s replies—clear and friendly? Short and snappy? Detailed and formal?",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Изтрий"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example response guidelines",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "SAVE": "Add and save (↵)",
            "PLACEHOLDER": "Type in another response guideline..."
          },
          "NEW": {
            "TITLE": "Add a response guideline",
            "CREATE": "Create",
            "CANCEL": "Отмени",
            "PLACEHOLDER": "Type in another response guideline...",
            "TEST_ALL": "Test all"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Search..."
        },
        "EMPTY_MESSAGE": "No response guidelines found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No response guidelines found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Response Guidelines added successfully",
            "ERROR": "There was an error adding response guidelines, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Response Guidelines updated successfully",
            "ERROR": "There was an error updating response guidelines, please try again."
          },
          "DELETE": {
            "SUCCESS": "Response Guidelines deleted successfully",
            "ERROR": "There was an error deleting response guidelines, please try again."
          }
        }
      },
      "SCENARIOS": {
        "TITLE": "Scenarios",
        "DESCRIPTION": "Give your assistant some context—like “what to do when a user is stuck,” or “how to act during a refund request.”",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Изтрий"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example scenarios",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "TOOLS_USED": "Tools used :"
          },
          "NEW": {
            "CREATE": "Add a scenario",
            "TITLE": "Create a scenario",
            "FORM": {
              "TITLE": {
                "LABEL": "Title",
                "PLACEHOLDER": "Enter a name for the scenario",
                "ERROR": "Scenario name is required"
              },
              "DESCRIPTION": {
                "LABEL": "Описание",
                "PLACEHOLDER": "Describe how and where this scenario will be used",
                "ERROR": "Scenario description is required"
              },
              "INSTRUCTION": {
                "LABEL": "How to handle",
                "PLACEHOLDER": "Describe how and where this scenario will be handled",
                "ERROR": "Scenario content is required"
              },
              "CREATE": "Create",
              "CANCEL": "Отмени"
            }
          }
        },
        "UPDATE": {
          "CANCEL": "Отмени",
          "UPDATE": "Update changes"
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Search..."
        },
        "EMPTY_MESSAGE": "No scenarios found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No scenarios found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Scenarios added successfully",
            "ERROR": "There was an error adding scenarios, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Scenarios updated successfully",
            "ERROR": "There was an error updating scenarios, please try again."
          },
          "DELETE": {
            "SUCCESS": "Scenarios deleted successfully",
            "ERROR": "There was an error deleting scenarios, please try again."
          }
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "FAQ_COUNT": "{n} FAQ | {n} FAQs",
      "SELECTED": "{count} selected",
      "SELECT_ALL": "Select all ({count})",
      "UNSELECT_ALL": "Unselect all ({count})",
      "BULK_DELETE_BUTTON": "Изтрий",
      "BULK_SYNC_BUTTON": "Refresh",
      "BULK_DELETE": {
        "TITLE": "Delete documents?",
        "DESCRIPTION": "Are you sure you want to delete the selected documents? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "Documents deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the documents, please try again."
      },
      "BULK_SYNC": {
        "SUCCESS_MESSAGE_ONE": "Refresh queued for 1 document",
        "SUCCESS_MESSAGE": "Refresh queued for {count} documents",
        "ZERO_MESSAGE": "No documents marked for refresh.",
        "ERROR_MESSAGE": "There was an error queuing the refresh, please try again."
      },
      "SYNC": {
        "QUEUED_MESSAGE": "Refresh queued. We'll update the document shortly.",
        "ERROR_MESSAGE": "Could not queue refresh, please try again."
      },
      "FILTERS": {
        "SOURCE": {
          "ALL": "All sources",
          "WEB": "Web pages",
          "PDF": "PDFs"
        },
        "STATUS": {
          "ANY": "Any status",
          "UPDATED": "Updated",
          "NEEDS_UPDATE": "Needs update",
          "UPDATING": "Updating",
          "FAILED": "Failed"
        },
        "SORT": {
          "RECENTLY_UPDATED": "Recently updated",
          "RECENTLY_CREATED": "Recently created"
        },
        "SEARCH_PLACEHOLDER": "Search..."
      },
      "SYNC_STATUS": {
        "SYNCED": "last updated {time}",
        "SYNCING": "updating...",
        "STALE_SYNC": "update stalled",
        "FAILED": "Failed to sync",
        "NEVER_SYNCED": "not updated yet"
      },
      "SYNC_ERRORS": {
        "NOT_FOUND": "Page not found",
        "ACCESS_DENIED": "Access denied",
        "TIMEOUT": "Page took too long to respond",
        "CONTENT_EMPTY": "Page returned empty content",
        "FETCH_FAILED": "Could not fetch page",
        "SYNC_ERROR": "Unexpected error",
        "DEFAULT": "Sync error"
      },
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "EMPTY": "No FAQs have been generated from this document yet."
      },
      "DETAILS": {
        "DESCRIPTION": "Review the crawled content and the FAQs generated from this source.",
        "SOURCE": "Source",
        "GENERATED_FAQS": "Generated FAQs",
        "LAST_UPDATED": "Last updated",
        "NOT_AVAILABLE": "Няма информация",
        "CONTENT_TAB": "Crawled content",
        "PDF_TAB": "PDF details",
        "CONTENT_TITLE": "Crawled content",
        "PDF_TITLE": "PDF file",
        "PDF_DESCRIPTION": "Review the original PDF source.",
        "CHARACTER_COUNT": "{count} characters extracted",
        "COPY_CONTENT": "Copy",
        "COPY_SUCCESS": "Crawled content copied to clipboard",
        "COPY_ERROR": "Could not copy crawled content",
        "VIEW_RAW": "View raw",
        "VIEW_PREVIEW": "View preview",
        "UNREADABLE_CONTENT": "Readable content could not be extracted from this document. You can view the raw extracted content.",
        "EMPTY_CONTENT": "No crawled content is available for this document yet."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "TYPE": {
          "LABEL": "Document Type",
          "URL": "URL",
          "PDF": "PDF File"
        },
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "PDF_FILE": {
          "LABEL": "PDF File",
          "CHOOSE_FILE": "Choose PDF file",
          "ERROR": "Please select a PDF file",
          "HELP_TEXT": "Maximum file size: 10MB",
          "INVALID_TYPE": "Please select a valid PDF file",
          "TOO_LARGE": "File size exceeds 10MB limit"
        },
        "NAME": {
          "LABEL": "Document Name (Optional)",
          "PLACEHOLDER": "Enter a name for the document"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_DETAILS": "Вижте детайлите",
        "SYNC_NOW": "Refresh now",
        "RETRY_SYNC": "Retry refresh",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FILTERED_TITLE": "No matching documents",
        "FILTERED_SUBTITLE": "Try changing the source, status, or search term.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "CUSTOM_TOOLS": {
      "HEADER": "Tools",
      "ADD_NEW": "Create a new tool",
      "SOFT_LIMIT_WARNING": "Having more than 10 tools may reduce the assistant's reliability in selecting the right tool. Consider removing unused tools for better results.",
      "EMPTY_STATE": {
        "TITLE": "No custom tools available",
        "SUBTITLE": "Create custom tools to connect your assistant with external APIs and services, enabling it to fetch data and perform actions on your behalf.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Custom Tools",
          "NOTE": "Custom tools allow your assistant to interact with external APIs and services. Create tools to fetch data, perform actions, or integrate with your existing systems to enhance your assistant's capabilities."
        }
      },
      "FORM_DESCRIPTION": "Configure your custom tool to connect with external APIs",
      "OPTIONS": {
        "EDIT_TOOL": "Edit tool",
        "DELETE_TOOL": "Delete tool"
      },
      "CREATE": {
        "TITLE": "Create Custom Tool",
        "SUCCESS_MESSAGE": "Custom tool created successfully",
        "ERROR_MESSAGE": "Failed to create custom tool"
      },
      "EDIT": {
        "TITLE": "Edit Custom Tool",
        "SUCCESS_MESSAGE": "Custom tool updated successfully",
        "ERROR_MESSAGE": "Failed to update custom tool"
      },
      "DELETE": {
        "TITLE": "Delete Custom Tool",
        "DESCRIPTION": "Are you sure you want to delete this custom tool? This action cannot be undone.",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "Custom tool deleted successfully",
        "ERROR_MESSAGE": "Failed to delete custom tool"
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use tools with Captain",
        "AVAILABLE_ON": "Captain Tools are only available in Business and Enterprise plans. Please upgrade to Business plan to use the feature.",
        "UPGRADE_PROMPT": "",
        "UPGRADE_NOW": "Open billing",
        "CANCEL_ANYTIME": ""
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "Captain Tools are only available in the paid plans.",
        "UPGRADE_PROMPT": "Please upgrade to a paid plan to use this feature.",
        "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
      },
      "TEST": {
        "BUTTON": "Test connection",
        "SUCCESS": "Endpoint returned HTTP {status}",
        "ERROR": "Connection failed",
        "DISABLED_HINT": "Testing is only available for endpoints without templates or request bodies."
      },
      "FORM": {
        "TITLE": {
          "LABEL": "Tool Name",
          "PLACEHOLDER": "Order Lookup",
          "ERROR": "Tool name is required",
          "MAX_LENGTH_ERROR": "Tool name must be {max} characters or fewer"
        },
        "DESCRIPTION": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Looks up order details by order ID"
        },
        "HTTP_METHOD": {
          "LABEL": "Method"
        },
        "ENDPOINT_URL": {
          "LABEL": "Endpoint URL",
          "PLACEHOLDER": "https://api.example.com/orders/{'{{'} order_id {'}}'}",
          "ERROR": "Valid URL is required"
        },
        "AUTH_TYPE": {
          "LABEL": "Authentication Type"
        },
        "AUTH_TYPES": {
          "NONE": "None",
          "BEARER": "Bearer Token",
          "BASIC": "Basic Auth",
          "API_KEY": "API Key"
        },
        "AUTH_CONFIG": {
          "BEARER_TOKEN": "Bearer Token",
          "BEARER_TOKEN_PLACEHOLDER": "Enter your bearer token",
          "USERNAME": "Username",
          "USERNAME_PLACEHOLDER": "Enter username",
          "PASSWORD": "Password",
          "PASSWORD_PLACEHOLDER": "Enter password",
          "API_KEY": "Header Name",
          "API_KEY_PLACEHOLDER": "X-API-Key",
          "API_VALUE": "Header Value",
          "API_VALUE_PLACEHOLDER": "Enter API key value"
        },
        "PARAMETERS": {
          "LABEL": "Parameters",
          "HELP_TEXT": "Define the parameters that will be extracted from user queries"
        },
        "ADD_PARAMETER": "Add Parameter",
        "PARAM_NAME": {
          "PLACEHOLDER": "Parameter name (e.g., order_id)"
        },
        "PARAM_TYPE": {
          "PLACEHOLDER": "Тип"
        },
        "PARAM_TYPES": {
          "STRING": "String",
          "NUMBER": "Number",
          "BOOLEAN": "Boolean",
          "ARRAY": "Array",
          "OBJECT": "Object"
        },
        "PARAM_DESCRIPTION": {
          "PLACEHOLDER": "Description of the parameter"
        },
        "PARAM_REQUIRED": {
          "LABEL": "Required"
        },
        "REQUEST_TEMPLATE": {
          "LABEL": "Request Body Template (Optional)",
          "PLACEHOLDER": "{'{'}\n  \"order_id\": \"{'{{'} order_id {'}}'}\"\n{'}'}"
        },
        "RESPONSE_TEMPLATE": {
          "LABEL": "Response Template (Optional)",
          "PLACEHOLDER": "Order {'{{'} order_id {'}}'} status: {'{{'} status {'}}'}"
        },
        "ERRORS": {
          "PARAM_NAME_REQUIRED": "Parameter name is required"
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "PENDING_FAQS": "Pending FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "SELECT_ALL": "Select all ({count})",
      "UNSELECT_ALL": "Unselect all ({count})",
      "SEARCH_PLACEHOLDER": "Search FAQs...",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Изтрий",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Всички"
      },
      "STATUS": {
        "TITLE": "Статус",
        "PENDING": "Предстоящ",
        "APPROVED": "Approved",
        "ALL": "Всички"
      },
      "PENDING_BANNER": {
        "TITLE": "Captain has found some FAQs your customers were looking for.",
        "ACTION": "Click here to review"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Approve",
        "EDIT_RESPONSE": "Редактирай",
        "DELETE_RESPONSE": "Изтрий"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "NO_PENDING_TITLE": "There are no more pending FAQs to review",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "CLEAR_SEARCH": "Clear active filters",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Прекъсване"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Входяща кутия",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
